import ImageGallerySection from '../components/Common/PlatformHeroSection';
import ChallengesSection from '../components/Common/PlatformSection';
import InfoCarouselSection from '../components/Common/PlatformCardSection';
import OutcomesSection from '../components/Common/PlatformOutcomeSection';
import KeyFocusSection from '../components/WomensCare/KeyFocusSection';
import WhyAvexaSection from '../components/WomensCare/WhyAvexa';

const WomensCare = () => {
  const heroButtons = [
    {
      label: 'Learn More',
      className: 'btn-secondary',
      onClick: () => {
        document.getElementById('gallery-section').scrollIntoView({ behavior: 'smooth' });
      },
    },
  ];

  const galleryImages = [
    {
      src: '/assets/platformWomen/hero1.svg',
      alt: 'Doctor examining child',
    },
    {
      src: '/assets/platformWomen/hero2.svg',
      alt: 'Healthcare professional',
    },
    {
      src: '/assets/platformWomen/hero3.svg',
      alt: 'Doctor with patient',
    },
    {
      src: '/assets/platformWomen/hero4.svg',
      alt: 'Nurse with patient',
    },
  ];

  const challengeCards = [
    {
      image: '/assets/platformWomen/2section-1.svg',
      title: 'Limited Access & Delayed Care',
      description: 'Many women face delays in preventive screenings and maternal services due to location, time, or resource constraints.',
    },
    {
      image: '/assets/platformWomen/2section-2.svg',
      title: 'Fragmented Health Data',
      description: 'Health information is often scattered across systems, making coordinated, holistic care difficult to achieve.',
    },
    {
      image: '/assets/platformWomen/2section-3.svg',
      title: 'Lack of Personalization',
      description: 'Generic healthcare models fail to consider women’s diverse biological, hormonal, and lifestyle needs.',
    },
    {
      image: '/assets/platformWomen/2section-4.svg',
      title: 'Poor Continuity of Care',
      description: 'Women often visit different doctors at different stages, and their records don’t stay connected — causing gaps in care.',
    },
    {
      image: '/assets/platformWomen/2section-5.svg',
      title: 'Low Preventive Awareness',
      description: 'Many women miss early health checkups because they don’t get enough reminders or information about preventive care.',
    },
    {
      image: '/assets/platformWomen/2section-6.svg',
      title: 'Limited Digital Support & Engagement',
      description: 'Most health systems don’t keep women actively involved in their care, leading to fewer follow-ups and missed check-ins.',
    },
  ];

  const cardsData = [
    {
      image: '/assets/platformWomen/3section-1.svg',
      // icon: Card1Icon,
      heading: 'AI-Powered Insights',
      subheading: 'Predict potential health risks early — from reproductive complications to chronic conditions — with advanced analytics.'
    },
    {
      image: '/assets/platformWomen/3section-2.svg',
      // icon: Card2Icon,
      heading: 'Digital Engagement Tools',
      subheading: 'Smart reminders, educational resources, and personalized communication that keep women involved in their care journey.'
    },
    {
      image: '/assets/platformWomen/3section-3.svg',
      heading: 'Remote Monitoring',
      subheading: 'Enable consultations, prenatal check-ins, and follow-ups from anywhere, ensuring seamless continuity of care.'
    },
    {
      image: '/assets/platformWomen/3section-4.svg',
      heading: 'Unified Health Data',
      subheading: 'Centralized, secure records that give providers a holistic view of each patient’s health.'
    },
  ];

  const outcomesCards = [
    {
      title: 'For Patients',
      benefits: [
        'Personalized, proactive health management',
        'Early detection and continuous monitoring',
        'Accessible digital consultations and education',
      ],
      image1: '/assets/platformWomen/4section-1.svg',
      image2: '/assets/platformWomen/4section-2.svg',
    },
    {
      title: 'For Providers',
      benefits: [
        'Centralized dashboards for all patient data',
        'Predictive risk alerts for timely intervention',
        'Improved efficiency and patient satisfaction',
      ],
      image1: '/assets/platformWomen/4section-3.svg',
      image2: '/assets/platformWomen/4section-4.svg',
    },
  ];

  // const discoverCards = [
  //   {  
  //     image: childCareImage,
  //     // icon: '👶',
  //     title: '👶Child Health Care',
  //     subtitle: 'Supporting the next generation with connected pediatric care.',
  //     link: '/child-care',
  //   },
  //   {
  //     image: behavioralHealthImage,
  //     // icon: '🧠',
  //     title: '🧠Behavioral Health',
  //     subtitle: 'Integrating mental wellness into everyday healthcare.',
  //     link: '/behavioral-health',
  //   },
  // ];

  const keyFocusAreas = [
    {
      title: 'Maternal & Prenatal Care',
      image: '/assets/platformWomen/5section-1.svg',
      description: 'digital prenatal check-ins, monitoring high-risk pregnancies, remote support.',
    },
    {
      title: 'Preventive Screenings',
      image: '/assets/platformWomen/5section-2.svg',
      description: 'reminders and AI-assisted risk detection for breast cancer, cervical cancer, etc.',
    },
    {
      title: 'Fertility & Reproductive',
      image: '/assets/platformWomen/5section-3.svg',
      description: 'cycle tracking integration, fertility treatment support, personalized engagement.',
    },
  ];

  const whyAvexaItems = [
    {
      title: 'Patient-Centric Approach:',
      description: 'Avexa goes beyond technology to focus on what truly matters — improving the health and well-being of every woman it serves.',
    },
    {
      title: 'Future-Ready Healthcare:',
      description: 'Combining AI insights, telehealth, and digital engagement, Avexa ensures seamless point-of-care management while staying adaptable to future needs.',
    },
  ];

  return (
    <div>
      {/* Image Gallery Section */}
        <ImageGallerySection
          title="Empowering Women's Health Through Intelligent, Connected Care"
          images={galleryImages}
        />

        {/* <div className="h-32 md:h-40 lg:h-48 bg-white"></div> */}
        <div className="h-14 md:h-18 lg:h-22 bg-white"></div>

    
      {/* Challenges Section */}
      <ChallengesSection
        title="Challenges in"
        highlightedText="Women's Healthcare"
        description="Women's health often faces barriers that limit quality and continuity of care. Despite advancements in medicine, many women still struggle with delayed diagnoses and limited access to personalized support."
        cards={challengeCards}
        showToday={true}
      />

<InfoCarouselSection
      backgroundColor="var(--primary-color)"
      title="Avexa's Intelligent Approach to"
      highlightedText="Women's Health"
      description="Avexa's Women's Health Care platform combines AI analytics, telehealth, and digital engagement tools to create a continuous, connected care experience. Our solution empowers both providers and patients with real-time insights and easy-to-use digital tools."
      cards={cardsData}
    />

    {/* Outcomes Section */}
      <OutcomesSection
        title="Better"
        highlightedText="Outcomes for Women"
        titleEnd="and Providers"
        description="Avexa bridges the gap between data and care, creating measurable benefits for patients and healthcare organizations alike."
        cards={outcomesCards}
      />

 {/* Key Focus Areas Section */}
<KeyFocusSection
        title="Areas"
        highlightedText="Key Focus"
        description="Digital women's health is key to Avexa's mission of creating inclusive, data-driven healthcare solutions that improve outcomes for every patient."
        focusAreas={keyFocusAreas}
      />

      {/* Why Avexa Section */}
      <WhyAvexaSection
        title="Envisioned It"
        highlightedText="Avexa"
        description="Digital women's health is key to Avexa's mission of creating inclusive, data-driven healthcare solutions that improve outcomes for every patient."
        visionItems={whyAvexaItems}
      />

    </div>
  );
};

export default WomensCare;